import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { PharmacyState } from '../states/pharmacy/pharmacy.state';
import { PricingOption } from '../interfaces/PricingOption';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BasicSubscriptionPlanGuard  {

  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  canActivate():
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    const pricingOption: PricingOption = this.store.selectSnapshot(PharmacyState)?.currentPharmacy?.pricingOption;

    if (pricingOption !== PricingOption.monthlyBasic && pricingOption !== PricingOption.annualBasic)
      return true;
    else this.router.navigateByUrl('/dashboard');

    return false;
  }
}
